export default [
    { id: 'start' },
    { id: 'diet-id' },
    { id: 'sex-birthday-height' },
    { id: 'weight' },
    { id: 'goal' },
    { id: 'activity-level' },
    { id: 'finish' },
];
